<template>
  <div class="dealer-shop-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="店铺详情" :showBack="true"></my-header>
    <div class="shop-detail">
      <div class="shop-info">
        <div class="top">
          <div class="shop-logo">
            <img :src="dealerShop.logo">
          </div>
          <div class="shop-other">
            <div class="shop-name">{{dealerShop.name}}</div>
            <div class="shop-auth">
              <div class="platform-auth"><img src="../../assets/icon-shop-auth.png"/> <div>平台认证</div></div>
              <div class="shop-deposit"><img src="../../assets/icon-shop-deposit.png"/><div>9万</div></div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="shop-location">{{dealerShop.location.name}}</div>
          <div class="shop-sales">销量<span class="num">{{dealerShop.sales || 0}}</span></div>
        </div>
      </div>
      <div v-if="dealerShop.intro" class="shop-intro">{{dealerShop.intro}}</div>
    </div>
    <div class="shop-tab-part">
      <div class="shop-tab-item" :class="{'tab-selected':tabSelected == '0'}" @click = "changeTab('0')">门店宝贝</div>
      <div class="shop-tab-item" :class="{'tab-selected':tabSelected == '1'}" @click = "changeTab('1')">门店地址</div>
      <div class="shop-tab-item" :class="{'tab-selected':tabSelected == '2'}" @click = "changeTab('2')">店铺二维码</div>
      <div class="shop-tab-item" :class="{'tab-selected':tabSelected == '3'}" @click = "changeTab('3')">评价</div>
    </div>
    <div v-if="tabSelected == '0' && productList.length>0" class="product-list">
      <div v-for="product in productList" class="product-item general-box-shadow" @click="toProductDetail(product.id,product.name)">
        <img class="product-image border-bottom-style" :src="product.image">
        <div class="product-name">{{product.name}}</div>
        <div class="product-sku">{{product.price}}/{{product.unit}}</div>
      </div>
    </div>
    <div class="black-page" v-if="tabSelected == '0' && productList.length == 0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">该店铺还未上架宝贝!</div>
    </div>
    <div v-if="tabSelected == '1'" class="shop-address-list">
      <div v-for="address in addressList" class="shop-address-item general-box-shadow">
        <div class="shop-address-item-name">{{address.name}}</div>
        <div><span class="label">联系人：</span><span class="label-info">{{address.contacts}}</span></div>
        <div><span class="label">电&nbsp;&nbsp;&nbsp;话：</span><span class="label-info">{{address.phone}}</span></div>
        <div class="shop-address-item-address">
          <div class="label">地&nbsp;&nbsp;&nbsp;址：</div><span class="label-info">{{address.address}}</span></div>
      </div>
    </div>
    <div v-if="tabSelected == '2'" class="dealer-detail general-box-shadow">
        <img :src="dealerShop.qrcode" @click = "previewImg(dealerShop.qrcode,dealerShop.qrcode)">
    </div>
    <evaluate-list v-if="tabSelected == '3'" :shop-id="shopId"/>
<!--    <div v-if="tabSelected == '3' && evaluateList.length>0" class="shop-evaluate-list">-->
<!--      <mt-loadmore style="font-size:0.24rem;color: #aaaaaa;position: relative" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">-->

<!--      </mt-loadmore>-->
<!--      <div v-for="evaluate in evaluateList" class="shop-evaluate-item general-box-shadow">-->
<!--        <img class="author" src="../../assets/icon/icon-defualt-avatar.png"/>-->
<!--        <div class="evaluate-info">-->
<!--          <div class="name">{{evaluate.phone}}</div>-->
<!--          <div class="date">{{evaluate.createTime | simpleDayFilter}}</div>-->
<!--          <div class="content">{{evaluate.content}}</div>-->
<!--          <div class='evaluate-additional' v-if="!!evaluate.additionalComments">-->
<!--            <div class="info">用户{{(evaluate.additionalComments.createTime - evaluate.createTime) / (1000 * 60 * 60 * 24)}}天后追评</div>-->
<!--            <div class='content'>{{evaluate.additionalComments.content}}</div>-->
<!--            <div class="piclist" v-if="evaluate.additionalComments.attachmentList.length > 0">-->
<!--              <template v-for="(attachment,idx) in evaluate.additionalComments.attachmentList">-->
<!--                <img class="pic" mode="aspectFill" :src="attachment.url" v-if="idx < 3"/>-->
<!--              </template>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="evaluate-score" v-if="evaluate.score === '1'">-->
<!--          <img src='../../assets/evaluate_score_bg.png' class='evaluate-score-bgimg'/>-->
<!--          <div class='score-info'>-->
<!--            <div class='score'>5.0</div>-->
<!--            <div class='unit'>评分</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="black-page" v-if="tabSelected == '3' && evaluateList.length == 0">-->
<!--      <img src="../../assets/icon-no-img.png">-->
<!--      <div class="tip">该店铺还未收到评价!</div>-->
<!--    </div>-->
    <div class="shop-footer border-top-style">
      <div @click="leaveMeg" class="footer-operation-left">
        <img src="../../assets/icon/icon-consult.png"><div>咨询</div>
      </div>
      <div v-if="!isFavoriteShop" @click="favoriteShop" class="footer-operation-left">
        <img  src="../../assets/icon/icon-shop-unfavorite.png">
        <div>收藏</div>
      </div>
      <div v-if="isFavoriteShop" @click="cancelFavoriteShop" class="footer-operation-left">
        <img src="../../assets/icon/icon-favorited.png">
        <div>收藏</div>
      </div>
      <div @click="goPayDeposit" class="footer-operation-right">对商家付订金</div>
    </div>
    <div v-if="showBig" class="big-img-container" @click="hiddenBigImg()">
      <img class="big-img"  :src="showImage">
      <div class="hidden-tip">轻触屏幕返回</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import shopService from '../../service/shop/ShopService'
  import productService from '../../service/product/ProductService'
  import favoriteService from '../../service/customer/FavoriteService'
  import tradeEvaluateService from '../../service/trade/TradeEvaluateService'
  import {imgUrl,shareIcon} from "../../config";
  import shareService from '../../service/share/ShareService'
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'
  import EvaluateList from "./EvaluateList";

  export default {
    name: 'ShopDetail',
    components: {
      EvaluateList,
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        shopId:'',
        dealerShop:{location:{}},
        tabSelected:'0',
        pageNo:1,
        addressList:[],
        evaluateList:[],
        productList:[],
        isFavoriteShop:false,
        isWechatBrowser:this.$verfyBrowserType(),
        showBig:false,
        showImage:'',
        shopName:'',
        shopIntro:''
      }
    },
    created(){
      this.shopName = this.$route.query.shopName;
      this.shopIntro = this.$route.query.shopIntro;
      this.shopId = this.$route.query.shopId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.tabSelected) {
        this.tabSelected = this.global.tabSelected;
        this.global.tabSelected = '';
      }
      if(this.tabSelected == 3){
        this.loadEvaluateList();
      }
      if(this.global.shopId){
        this.shopId = this.global.shopId;
        this.global.shopId = '';
      }
      this.loadShopDetail();
      this.loadProductList();
      session.isLogin().then(flag => {
        if(flag){
          this.checkFavoriteShop();
        }
      });
      this.initWechatShare();
    },
    methods: {
      async loadShopDetail(){
        let {code,msg,data} = await shopService.detail(this.shopId);
        if(code == '0'){
          this.dealerShop = data.shop;
          this.addressList = data.addressList;
        }else {
          Toast(msg);
        }
      },
      async initWechatShare(){
        let title = this.shopName;// 分享标题
        let desc = this.shopIntro; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      previewImg(currentImage,previewImage){
        let previewImageList = [];
        previewImageList.push(previewImage);
        wx.previewImage({
          current: currentImage, // 当前显示图片的http链接
          urls: previewImageList // 需要预览的图片http链接列表

        });
      },
      async loadProductList(){
        let {code,msg,data} = await productService.list('',this.shopId,this.pageNo);
        if(code == '0'){
          for(let product of data.productList){
            if(product.name.length>10){
              product.name = product.name.substring(0,8)+'...'
            }
            this.productList.push(product)
          }
        }else {
          Toast(msg);
        }
      },
      async loadEvaluateList(){
        let {code,msg,data} = await tradeEvaluateService.list(this.shopId,this.pageNo);
        if(code == '0'){
          this.evaluateList = data.evaluateList;
          for (let evaluate of this.evaluateList){
            evaluate.phone = evaluate.phone.substring(0,3)+"****"+evaluate.phone.substring(7,11);
          }
        }else {
          Toast(msg);
        }
      },
      changeTab(tabSelected){
        this.tabSelected = tabSelected;
        if(tabSelected == 3){
          this.loadEvaluateList();
        }
      },
      toProductDetail(productId,productName){
        this.global.tabSelected = this.tabSelected;
        this.global.shopId = this.shopId;
        this.$router.push({name: 'ProductDetail', query: {productId,shopId:this.shopId,productName}})
      },
      leaveMeg(){
        if(this.dealerShop.msgQrcode){
          let shopQrcode = imgUrl + this.dealerShop.msgQrcode
          this.$router.push({name: 'ShopQrcode', query: {shopQrcode}})
        }else {
          Toast('该商家暂未上传二维码');
        }
      },
      async checkFavoriteShop(){
        let {code,msg,data} = await favoriteService.favoriteCheck(this.shopId,'2');
        if(code == '0'){
          this.isFavoriteShop = data;
        }else {
          Toast(msg);
        }
      },
      async favoriteShop(){
        const isLogin = await session.isLogin();
        if(isLogin){
          let {code,msg,data} = await favoriteService.addFavorite(this.shopId,'2');
          if(code == '0'){
            this.isFavoriteShop = !this.isFavoriteShop;
            Toast('店铺收藏成功!');
          }else {
            Toast('店铺收藏失败!');
          }
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      async cancelFavoriteShop(){
        let {code,msg,data} = await favoriteService.removeFavorite(this.shopId,'2');
        if(code == '0'){
          this.isFavoriteShop = !this.isFavoriteShop;
          Toast('店铺取消收藏成功!');
        }else {
          Toast('店铺取消收藏失败!');
        }
      },
      //对商家付订金
      goPayDeposit(){
        if(this.dealerShop.depositSwitch != '1'){
          Toast('暂时不能对该店铺付订金!');
        } else {
          this.global.tabSelected = this.tabSelected;
          this.global.shopId = this.shopId;
          this.$router.push({name: 'OfflineDeposit', query: {shopId:this.shopId,type:'3'}})
        }
      },
      //对商家付全款
      goPayTailMoney(){
        this.global.tabSelected = this.tabSelected;
        this.global.shopId = this.shopId;
        this.$router.push({name: 'OfflineTailMoney', query: {shopId:this.shopId,type:'1'}})
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/style/common.scss';
  .dealer-shop-detail-page{
    padding-bottom: 1rem;
    background-color: white;
    font-size: 0.32rem;
    color: #7f7d7c;
    height: 100%;
    overflow: scroll;
    .shop-detail{
      padding-top: 0.32rem;
      padding-bottom: 0.2rem;
      border-bottom: solid 8px #f7f6f5;
      .shop-info{
        width: 6.9rem;
        height: 2.8rem;
        margin: 0 auto;
        background: url("../../assets/icon-default-detail-top-bg.png") no-repeat;
        background-size: 100%;
        color: white;
        .top{
          display: flex;
          padding: 0.55rem 0rem 0.2rem 0.2rem;
          .shop-other{
            padding-left: 0.3rem;
            font-size: 0.36rem;
            font-weight: bold;
            .shop-name{
              padding-left: 0.1rem;
            }
            .shop-auth{
              display: flex;
              width: 2.95rem;
              height: 0.4rem;
              line-height: 0.45rem;
              border-radius: 0.4rem;
              margin-top: 0.19rem;
              background: white;
              font-size: 0.24rem;
              color: #feac00;
              img{
                width: 0.27rem;
                height: 0.28rem;
                margin-top: 0.06rem;
                margin-right: 0.1rem;
              }
              .platform-auth{
                display: flex;
                padding-left: 0.23rem;
              }
              .shop-deposit{
                display: flex;
                padding-left: 0.29rem;
              }
            }
          }
        }
        .bottom{
          display: flex;
          line-height: 1;
          .shop-location{
            margin-top: 0.03rem;
            padding-left: 0.5rem;
          }
          .shop-sales{
            margin-top: -0.05rem;
            padding-left: 0.67rem;
            font-size: 0.28rem;
            .num{
              margin-left: 0.2rem;
              font-size: 0.4rem;
              font-weight: bold;
            }
          }
        }
        .shop-logo{
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 1.2rem;
          background: white;
          text-align: center;
          img{
            width: 1.12rem;
            height: 1.12rem;
            border-radius: 1.16rem;
            vertical-align: middle;
            margin: 0.04rem auto;
          }
        }
      }
      .shop-intro{
        width: 6.7rem;
        padding-left: 0.3rem;
        padding-top: 0.15rem;
        line-height: 0.5rem;
        text-align: justify;
      }
    }
    .product-list{
      display: flex;
      flex-flow: row wrap;
      .product-item{
        width: 3.3rem;
        margin-left: 0.3rem;
        margin-bottom: 0.3rem;
        font-weight: bold;
        .product-image{
          display: block;
          width: 3.3rem;
          height: 3.3rem;
          border-top-left-radius: 0.08rem;
          border-top-right-radius: 0.08rem;
        }
        .product-name{
          padding: 0.2rem 0.2rem 0 0.2rem;
          color: #191818;
        }
        .product-sku{
          padding-left: 0.2rem;
          padding-bottom: 0.17rem;
          color: #d54a33;
        }
      }
    }
    .shop-address-list{
      padding: 0 0.3rem;
      .shop-address-item{
        padding: 0.25rem 0.4rem ;
        margin-bottom: 0.2rem;
        border-radius: 0.08rem;
        line-height: 0.5rem;
        font-size: 0.32rem;
        color: #191818;
        .shop-address-item-name{
          font-size: 0.36rem;
          font-weight: bold;
        }
        .shop-address-item-address{
          display: flex;
        }
        .label{
          font-size: 0.28rem;
          color: #7f7d7c;
        }
        .label-info{
          font-size: 0.28rem;
          color: #191818;
        }
      }
    }
    .dealer-detail{
      width: 6.2rem;
      margin: 0 auto 0.3rem;
      padding: 0.3rem 0.3rem 0 0.4rem;
      img{
        width: 100%;
      }
    }
    .shop-evaluate-list{
      width: 6.9rem;
      margin: 0 auto;
      overflow: scroll;
      .shop-evaluate-item{
        position: relative;
        display: flex;
        margin-bottom: 0.2rem;
        .author{
          width: 0.88rem;
          height: 0.88rem;
          flex-grow: 0;
          flex-shrink: 0;
          border-radius: 0.88rem;
          margin: 0.2rem;
        }
        .evaluate-info{
          margin-top: 0.3rem;
          margin-bottom: 0.3rem;
          padding-right: .2rem;
          width: 1rem;
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 0.28rem;
          color: #191818;
          .date{
            margin-bottom: 0.09rem;
            font-size: 0.24rem;
            color: #7f7d7c;
          }
          .content{
            font-size: 0.32rem;
          }
          .evaluate-additional{
            margin-top: .10rem;
            font-size: .32rem;
            color: #191818;
            .info{
              font-size: .28rem;
              color: #D54A33;
            }
            .content{
              margin-top: .05rem;
            }
            .piclist{
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              align-items: center;
              margin-top: .1rem;
              .pic{
                width: 1.60rem;
                height: 1.60rem;
                border-radius: .10rem;
                margin:0;
              }
            }
          }
        }
        .evaluate-score{
          width: .58rem;
          height: .78rem;
          position: absolute;
          right: .22rem;
          top: 0px;
          .evaluate-score-bgimg{
            width: 100%;
            height: 100%;
            border-radius: 0px;
            margin: 0;
            display: block;
            position: absolute;
            z-index: 1;

          }
          .score-info{
            position: relative;
            z-index: 2;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            padding-top: .10rem;
            .score{
              line-height: 1em;
              font-size: .22rem;
              font-weight: bold;
              color: #fff;
            }
            .unit{
              line-height: 1em;
              font-size: .18rem;
              color: #fff;
            }
          }
        }
      }
    }
    .shop-tab-part{
      display: flex;
      height: 0.95rem;
      padding-left: 0.3rem;
      line-height: 0.95rem;
      .shop-tab-item{
        padding-right: 0.3rem;
      }
      .tab-selected{
        font-size: 0.36rem;
        font-weight: bold;
        color: #191818;
      }
    }
    .shop-footer{
      position: fixed;
      display: flex;
      align-items: center;
      bottom: 0rem;
      width: 100%;
      height: 0.97rem;
      background: white;
      font-size: 0.24rem;
      z-index: 1111;
      .footer-operation-left{
        width:1.2rem;
        display:flex;
        flex-flow:column wrap;
        align-items:center;
        color: #222633;
        img{
          width: 0.38rem;
          margin-bottom: 0.07rem;
        }
      }
      .footer-operation-right{
        width:2.3rem;
        height: 0.6rem;
        margin-left: 2.3rem;
        line-height:0.65rem;
        border-radius: 0.6rem;
        background-color:#feac00;
        text-align:center;
        font-size: 0.3rem;
        color:#ffffff;
        font-weight: inherit;
      }
    }
  }
</style>
